const TYPE_A = {
    0: ["account_number"]
}

const TYPE_B = {
    0: ["account_number", "bank_code"]
}

const TYPE_B2 = {
    0: ["account_number", "routing_number"]
}

const TYPE_B3 = {
    0: ["routing_number", "account_number"]
}

const TYPE_C = {
    0: ["account_number"],
    1: ["bank_code", "routing_number"]
}
const TYPE_D = {
    0: ["routing_number"],
    1: ["bank_code"],
    2: ["account_number"]
}
const TYPE_D2 = {
    0: ["bank_code"],
    1: ["routing_number"],
    2: ["account_number"],
    3: ["suffix"]
}

export default {

    getList(pm) {
        if(pm && pm.configuration) {
          switch(pm.gateway_name) {
            case 'GOCARDLESS':
              switch (pm.configuration.scheme) {
                  case 'SEPA':
                      if(pm.type == "sepa_instant_transfer") {
                        return this.gocardless_sepa_instant_transfer
                      }
                      return this.gocardless_sepa;
                  case 'BACS':
                      return this.gocardless_bacs;
                  case 'Autogiro':
                      return this.gocardless_autogiro;
                  case 'ACH':
                      return this.gocardless_ach;
                  case 'BECS':
                      return this.gocardless_becs;
                  case 'PAD':
                      return this.gocardless_pad;
                  case 'BECS(NZ)':
                      return this.gocardless_becs_nz;
              }
            case 'CYBERSOURCE':
              switch (pm.configuration.scheme) {
                case 'ACH':
                    return this.cybersource_ach;
              }
          }
        }
        switch(pm.gateway_name) {
          case 'STRIPE':
            switch(pm.type) {
              case 'sofort':
                return this.stripe_sofort
            }
          case 'CHECKOUT_COM':
            switch(pm.type) {
              case 'bancontact':
                return this.checkout_com_bancontact
            }
          case 'ADYEN':
            switch(pm.type){
                case 'klarna_pay_now':
                    return this.adyen_klarna_pay_now
            }
        }
        return [];
    },

    gocardless_bacs: [
        {
            display_name: "United Kingdom",
            value: "GB",
            local_fields: TYPE_B2
        }
    ],

    gocardless_autogiro: [
        {
            display_name: "Sweden",
            value: "SE",
            local_fields: TYPE_B2
        }
    ],
    gocardless_ach: [
        {
            display_name: "United States",
            value: "US",
            local_fields: TYPE_B
        }
    ],
    cybersource_ach: [
        {
            display_name: "United States",
            value: "US",
            local_fields: TYPE_B2
        }
    ],
    gocardless_becs: [
        {
            display_name: "Australia",
            value: "AU",
            local_fields: TYPE_B3
        }
    ],
    gocardless_pad: [
        {
            display_name: "Canada",
            value: "CA",
            local_fields: TYPE_D
        }
    ],
    gocardless_becs_nz: [
        {
            display_name: "New Zealand",
            value: "NZ",
            local_fields: TYPE_D2
        }
    ],

    gocardless_sepa_instant_transfer: [
        {
            display_name: "Germany",
            value: "DE",
            local_fields: TYPE_B
        }
    ],

    gocardless_sepa: [
        {
            display_name: "Austria",
            value: "AT",
            local_fields: TYPE_B
        },
        {
            display_name: "Belgium",
            value: "BE",
            local_fields: TYPE_A
        },
        {
            display_name: "Cyprus",
            value: "CY",
            local_fields: TYPE_C
        },
        {
            display_name: "Estonia",
            value: "EE",
            local_fields: TYPE_A
        },
        {
            display_name: "Finland",
            value: "FI",
            local_fields: TYPE_B
        },
        {
            display_name: "Aland Islands",
            value: "AX",
            local_fields: TYPE_B
        },
        {
            display_name: "France",
            value: "FR",
            local_fields: TYPE_C
        },
        {
            display_name: "French Guiana",
            value: "GF",
            local_fields: TYPE_C
        },
        {
            display_name: "Guadeloupe",
            value: "GP",
            local_fields: TYPE_C
        },
        {
            display_name: "Mayotte",
            value: "YT",
            local_fields: TYPE_C
        },
        {
            display_name: "Reunion",
            value: "RE",
            local_fields: TYPE_C
        },
        {
            display_name: "Saint Barthélemy",
            value: "BL",
            local_fields: TYPE_C
        },
        {
            display_name: "Saint Martin",
            value: "MF",
            local_fields: TYPE_C
        },
        {
            display_name: "Saint Pierre and Miquelon",
            value: "PM",
            local_fields: TYPE_C
        },
        {
            display_name: "Germany",
            value: "DE",
            local_fields: TYPE_B
        },
        {
            display_name: "Greece",
            value: "GR",
            local_fields: TYPE_C
        },
        {
            display_name: "Ireland",
            value: "IE",
            local_fields: TYPE_B2
        },
        {
            display_name: "Italy",
            value: "IT",
            local_fields: TYPE_C
        },
        {
            display_name: "Latvia",
            value: "LV",
            local_fields: TYPE_B
        },
        {
            display_name: "Lithuania",
            value: "LT",
            local_fields: TYPE_B
        },
        {
            display_name: "Luxembourg",
            value: "LU",
            local_fields: TYPE_B
        },
        {
            display_name: "Malta",
            value: "MT",
            local_fields: TYPE_B2
        },
        {
            display_name: "Monaco",
            value: "MC",
            local_fields: TYPE_C
        },
        {
            display_name: "Netherlands",
            value: "NL",
            local_fields: TYPE_B
        },
        {
            display_name: "Portugal",
            value: "PT",
            local_fields: TYPE_C
        },
        {
            display_name: "San Marino",
            value: "SM",
            local_fields: TYPE_C
        },
        {
            display_name: "Slovakia",
            value: "SK",
            local_fields: TYPE_B
        },
        {
            display_name: "Slovenia",
            value: "SI",
            local_fields: TYPE_B
        },
        {
            display_name: "Spain",
            value: "ES",
            local_fields: TYPE_C
        },
    ],
    stripe_sofort: [
      {
        display_name: 'Austria',
        value: 'AT'
      },
      {
        display_name: 'Belgium',
        value: 'BE'
      },
      {
        display_name: 'Germany',
        value: 'DE'
      },
      {
        display_name: 'Italy',
        value: 'IT'
      },
      {
        display_name: 'Netherlands',
        value: 'NL'
      },
      {
        display_name: 'Spain',
        value: 'ES'
      },
    ],

    adyen_klarna_pay_now: [
        {
          display_name: 'Austria',
          value: 'AT'
        },
        {
          display_name: 'Germany',
          value: 'DE'
        },
        {
          display_name: 'Netherlands',
          value: 'NL'
        },
        {
          display_name: "Sweden",
          value: "SE",
        },
      ],

    checkout_com_bancontact: [
			{
        display_name: 'Belgium',
        value: 'BE'
			}
    ]
}
